module.exports = __webpack_public_path__ + "assets/svg/Icons/32/time-red-6a204a.svg";